// extracted by mini-css-extract-plugin
module.exports = {"statValue":"FlashReportCards_statValue__2ryEA"};